module.exports = __webpack_public_path__ + "img/0a.0d96c3f7.png";